import useMondayBoardsPicker from "frontend/hooks/use-monday-boards-picker";
import { MondayBoard } from "shared/integrations/mapper";
import { useEffect, useState } from "react";
import DropdownPicker, { DropdownPickerStyle } from "frontend/ui-components/picker/dropdown-picker";

export function LiveIntegrationBoardPicker({
  mondayIntegrationId,
  selectedBoardId,
  onSelectBoard,
  pickerStyle = DropdownPickerStyle.Dark,
  showClearButton = false,
  styles: dropdownStyles,
  width,
}: {
  mondayIntegrationId: string;
  selectedBoardId?: string;
  onSelectBoard: (board: MondayBoard | null) => void;
  pickerStyle?: DropdownPickerStyle;
  showClearButton?: boolean;
  styles?: Parameters<typeof DropdownPicker>[0]["styles"];
  width?: number;
}) {
  const [selectedBoard, setSelectedBoard] = useState<string | undefined>(selectedBoardId);
  const { boards, isLoading } = useMondayBoardsPicker(mondayIntegrationId, "");

  useEffect(() => {
    const board = boards.find((board) => board.id === selectedBoard) ?? null;
    onSelectBoard(board);
  }, [selectedBoard, boards]);

  const handleClearSelection = () => {
    setSelectedBoard(undefined);
  };

  return (
    <DropdownPicker
      options={boards}
      isSelected={(board) => board.id === selectedBoard}
      placeholder={isLoading ? "Loading boards..." : "Select a board"}
      titles={(board) => board.name}
      enabled={!isLoading}
      onChange={(board) => setSelectedBoard(board.id)}
      optionsPickerStyle={{ fontSize: 12 }}
      pickerStyle={pickerStyle}
      styles={dropdownStyles}
      width={width}
      showClearButton={showClearButton}
      onClear={handleClearSelection}
      optionsContainerStyle={{
        backgroundColor: "#1e1e1e",
        borderRadius: "10px",
        color: "white",
        border: "1px solid #5F5F60",
      }}
      optionRenderer={({ option, selected }) => ({
        element: <div>{option.name}</div>,
        enabled: true,
        customStyle: { background: selected ? "#393939" : "none" },
      })}
    />
  );
}
